export const colors = {
   

    bg1: "#2D2329",
    bg2: "#F6F9FF",
    white: "#ffffff",
    gr_bg:"linear-gradient(90deg, #8C3039 0%, #6A262D 100%)",
    gr_bg2: "linear-gradient(90deg, #8C3039 100%, #6A262D 0%)",
    copy_bg: "#122340",
    blue: "#2c97ea",
    green: "#6a262d",
    green2: "#6a262d",
    red: "#ff6f6f",
    purple: "#84479c",
    yellow: "#fbab19",
    black1: "#182B49",
    black2: "#444444",
    text1: "#555555",
    text2: "#666666",
    text3: "#969696",
    text4: "#aaaaaa",
    text5: "#cccccc",
    border1: "#eeeeee",
    border2: "#3e3e3e",
    border3: "#dddddd",
    footer1: "#1a1b25",
    footer2: "#16171f",
    ftext: "#8D8E92",

}

export const fonts = {

    roboto: "'Roboto', sans-serif",
    poppins: "'Poppins', sans-serif",

}